export enum CustomerType {
    Account = 0,
    Lead = 1,
}
